export default "__VITE_ASSET__CJYB_ugU__"